import { useEffect, useState } from "react";

import HeaderPersistentBar from "components/header/HeaderPersistentBar";
import HeaderContent from "./HeaderContent";
import MismatchBanner from "components/header/MismatchBanner";
import StickyHeaderContainer from "components/utility/sticky-header/StickyHeaderContainer";
import StickyHeader from "components/utility/sticky-header/StickyHeader";
import StickyPromoBanner from "components/sticky-promo-banner/StickyPromoBanner";
import getInitialData from "components/utility/api/GetInitialData";

// Leaving old header commented out in case debugging is needed
const HeaderStandalone = () => {
	const mismatchBannerData = window[`mismatchBanner`] || null;
	const topPersistentBarData = window[`topPersistentBar`] || null;
	const stickyPromoBannerData = window[`stickyPromoBanner`] || null;
	const legacyHeaderContentDataFromWindow = window[`publicGlobalNav`] || null;

	const [legacyHeaderContentData, setLegacyHeaderContentData] = useState(
		legacyHeaderContentDataFromWindow
	);

	useEffect(() => {
		async function fetchData() {
			const devLegacyHeaderContentData = await getInitialData("publicGlobalNav", null);
			setLegacyHeaderContentData(devLegacyHeaderContentData);
		}
		if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
			fetchData();
		}
	}, []);

	return (
		<StickyHeaderContainer>
			<StickyHeader>
				<MismatchBanner data={mismatchBannerData} />
				<HeaderPersistentBar
					color="cement"
					type="top"
					dataset={{ withoutLine: "true", publicSite: "true" }}
					data={topPersistentBarData}
				/>
				<StickyPromoBanner data={stickyPromoBannerData} />
				{legacyHeaderContentData && <HeaderContent data={legacyHeaderContentData} />}
			</StickyHeader>
		</StickyHeaderContainer>
	);
};

export default HeaderStandalone;
